import React, { useState } from 'react';
import { StatusBadge } from '../components/StatusBadge';
import { RepaymentDetailModal } from '../components/RepaymentDetailModal';
import { Search } from 'lucide-react';
export function RepaymentsPage() {
  const [statusFilter, setStatusFilter] = useState('Active');
  const [dueFilter, setDueFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRepayment, setSelectedRepayment] = useState<any>(null);
  // Mock Data
  const [repayments, setRepayments] = useState([{
    id: 'RP-88921',
    loanId: 'LN-10234',
    installment: '5 / 12',
    due: '15 Feb 2026',
    amount: 'PKR 42,000',
    penalty: 'PKR 1,500',
    status: 'Overdue',
    principal: 'PKR 40,000',
    interest: 'PKR 2,000',
    total: 'PKR 43,500'
  }, {
    id: 'RP-88922',
    loanId: 'LN-10235',
    installment: '2 / 12',
    due: '18 Feb 2026',
    amount: 'PKR 110,000',
    penalty: '—',
    status: 'Due',
    principal: 'PKR 100,000',
    interest: 'PKR 10,000',
    total: 'PKR 110,000'
  }, {
    id: 'RP-88923',
    loanId: 'LN-10236',
    installment: '1 / 6',
    due: '20 Feb 2026',
    amount: 'PKR 125,000',
    penalty: '—',
    status: 'Upcoming',
    principal: 'PKR 120,000',
    interest: 'PKR 5,000',
    total: 'PKR 125,000'
  }, {
    id: 'RP-88924',
    loanId: 'LN-10234',
    installment: '4 / 12',
    due: '15 Jan 2026',
    amount: 'PKR 42,000',
    penalty: '—',
    status: 'Settled',
    principal: 'PKR 40,000',
    interest: 'PKR 2,000',
    total: 'PKR 42,000'
  }, {
    id: 'RP-88925',
    loanId: 'LN-10237',
    installment: '3 / 12',
    due: '10 Feb 2026',
    amount: 'PKR 28,000',
    penalty: 'PKR 500',
    status: 'Overdue',
    principal: 'PKR 25,000',
    interest: 'PKR 3,000',
    total: 'PKR 28,500'
  }]);
  const handleRowClick = (item: any) => {
    setSelectedRepayment(item);
    setIsModalOpen(true);
  };
  const handleMarkPaid = () => {
    if (selectedRepayment) {
      setRepayments(prev => prev.map(item => item.id === selectedRepayment.id ? {
        ...item,
        status: 'Settled',
        penalty: '—'
      } : item));
      setIsModalOpen(false);
    }
  };
  const filteredData = repayments.filter(item => {
    const matchesStatus = statusFilter === 'All' || statusFilter === 'Active' && item.status !== 'Settled' || statusFilter === 'Settled' && item.status === 'Settled';
    const matchesDue = dueFilter === 'All' || item.status === dueFilter;
    const matchesSearch = item.loanId.toLowerCase().includes(searchTerm.toLowerCase()) || item.id.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesStatus && matchesDue && matchesSearch;
  });
  return <div className="space-y-6" data-id="element-816">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-817">
        <div data-id="element-818">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-819">Repayments</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-820">
            Monitor and manage repayment schedules.
          </p>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm flex flex-col sm:flex-row gap-4 items-end" data-id="element-821">
        <div className="w-full sm:flex-1" data-id="element-822">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-823">
            Search Loan ID
          </label>
          <div className="relative rounded-md shadow-sm" data-id="element-824">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-825">
              <Search className="h-4 w-4 text-gray-400" aria-hidden="true" data-id="element-826" />
            </div>
            <input type="text" className="block w-full rounded-md border-gray-300 pl-10 focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" placeholder="LN-10..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-827" />
          </div>
        </div>

        <div className="w-full sm:w-48" data-id="element-828">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-829">
            Repayment Due
          </label>
          <select value={dueFilter} onChange={e => setDueFilter(e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-830">
            <option value="All" data-id="element-831">All</option>
            <option value="Due" data-id="element-832">Due Today</option>
            <option value="Overdue" data-id="element-833">Overdue</option>
            <option value="Upcoming" data-id="element-834">Upcoming</option>
          </select>
        </div>

        <div className="w-full sm:w-48" data-id="element-835">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-836">
            Status
          </label>
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-837">
            <option value="Active" data-id="element-838">Active (Unpaid)</option>
            <option value="Settled" data-id="element-839">Settled (Paid)</option>
            <option value="All" data-id="element-840">All</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-lg overflow-hidden" data-id="element-841">
        <div className="overflow-x-auto" data-id="element-842">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-843">
            <thead className="bg-gray-50" data-id="element-844">
              <tr data-id="element-845">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-846">
                  Repayment ID
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-847">
                  Loan ID
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-848">
                  Installment
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-849">
                  Due Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-850">
                  Amount Due
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-851">
                  Penalty
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-852">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-853">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white" data-id="element-854">
              {filteredData.map(item => <tr key={item.id} className="hover:bg-gray-50 transition-colors cursor-pointer" onClick={() => handleRowClick(item)} data-id="element-855">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-856">
                    {item.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-857">
                    {item.loanId}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-858">
                    {item.installment}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-859">
                    {item.due}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-860">
                    {item.amount}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-red-600" data-id="element-861">
                    {item.penalty}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-862">
                    <StatusBadge status={item.status} data-id="element-863" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-864">
                    <button onClick={e => {
                  e.stopPropagation();
                  handleRowClick(item);
                }} className="text-blue-600 hover:text-blue-900" data-id="element-865">
                      View
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <RepaymentDetailModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onMarkPaid={handleMarkPaid} data={selectedRepayment} data-id="element-866" />
    </div>;
}